import { useDispatch, useSelector } from "react-redux";
import {
  saveProjectSettings,
  updateSettingOptionState,
} from "../../../../../Redux/actions/projectActions";
import LayoutDisclosure from "../LayoutDisclosure";
import "./ScrollEndBehavior.css";

export default function ScrollEndBehavior() {
  const dispatch = useDispatch();
  const settings = useSelector((state) => state?.project?.settings ?? {});
  const enabled = Boolean(settings?.end_hold_enabled);

  const toggle = () => {
    const next = !enabled;
    const nextSettings = { ...settings, end_hold_enabled: next };
    dispatch(updateSettingOptionState("end_hold_enabled", next));
    dispatch(saveProjectSettings(nextSettings));
  };

  return (
    <LayoutDisclosure title="End Behavior">
      <div className="scroll-end-behavior">
        <div>
          <div className="scroll-end-behavior__label">
            Hold final block at center
          </div>
          <div className="scroll-end-behavior__help">
            Holds for 9 seconds, then fades out for 1 second.
          </div>
        </div>
        <button
          type="button"
          className={`scroll-end-behavior__switch${
            enabled ? " is-on" : ""
          }`}
          role="switch"
          aria-checked={enabled}
          aria-label="Hold final block at center"
          onClick={toggle}
        >
          <span className="scroll-end-behavior__knob" />
        </button>
      </div>
    </LayoutDisclosure>
  );
}
